import { http } from '@/http';

export const confirmPhoneOtp = async (
	ulid: string,
	otp: string,
	clientId: string,
) =>
	await http.post<{ message: string; next_step: string }>(
		`v2/onboarding/${ulid}/phone/confirm-otp`,
		{
			otp,
			client_id: clientId,
		},
	);
